export default {
  lang: { name: '中文', code: 'zh', flag: '🇨🇳' },
  common: {
    whatsapp: 'WhatsApp',
    email: '邮箱',
    sendEmail: '发送邮件',
    sendInquiry: '发送询盘',
    contactSupplier: '联系供应商',
    viewDetails: '查看详情',
    viewAll: '查看全部',
    loading: '加载中…',
    backHome: '返回首页',
    negotiable: '价格可议',
    perPiece: '/ 件',
    moq: '起订:1件',
    inStock: '现货',
    refresh: '换一张',
    chatNow: '立即沟通',
    chooseContact: '选择销售联系人',
    notFound: '暂无结果'
  },
  nav: {
    home: '首页',
    products: '产品中心',
    examples: '案例',
    about: '关于我们',
    contact: '联系我们'
  },
  header: {
    callUs: '咨询热线',
    quickNav: '快速导航',
    tapExpand: '点击展开',
    tapClose: '点击收起',
    language: '语言'
  },
  hero: {
    tag: '舞台灯光制造商 · 始于2010',
    title: '专业舞台灯光<br>点亮每一场演出',
    sub: '高品质舞台灯光方案 — 摇头灯、帕灯、频闪灯及LED灯。产品远销50多个国家。',
    browseProducts: '浏览产品',
    chatWa: 'WhatsApp 咨询'
  },
  quicknav: {
    title: '快速导航',
    products: '产品中心',
    productsDesc: '浏览全部舞台灯光',
    examples: '案例',
    examplesDesc: '真实项目展示',
    about: '关于我们',
    aboutDesc: '工厂及公司介绍',
    contact: '联系销售',
    contactDesc: 'WhatsApp 快速报价'
  },
  featured: {
    eyebrow: '热销推荐',
    title: '主推产品',
    desc: '最受欢迎的舞台灯光 — 深受50多个国家客户信赖。',
    viewAll: '查看全部产品',
    badge: '热销',
    empty: '暂无主推商品。'
  },
  sections: {
    whyEyebrow: '为什么选择我们',
    whyTitle: '我们的优势',
    whyDesc: '凭借丰富经验，我们在创新与规模化生产方面均表现出色，提供符合全球标准的高品质舞台灯光解决方案。',
    svcEyebrow: '我们的服务',
    svcTitle: '服务范围',
    svcDesc: '全方位舞台灯光解决方案 — 从定制产品到全球物流及远程技术支持。',
    contactEyebrow: '联系我们',
    contactTitle: '发送询盘',
    contactDesc: '更喜欢邮件？留下您的信息，我们将在24小时内回复。'
  },
  cta: {
    title: '几分钟内获取报价？',
    desc: '在 WhatsApp 上联系我们 — 销售团队在工作时间通常10分钟内回复。',
    emailUs: '邮件咨询'
  },
  product: {
    heroTitle: '产品中心',
    heroDesc: '高品质舞台灯光，控制灵活、稳定性强、安全可靠 — 为每一场演出和活动保驾护航。',
    searchPlaceholder: '按关键字搜索产品...',
    search: '搜索',
    sortBy: '排序',
    sortDefault: '默认',
    sortNewest: '最新',
    sortAsc: '价格从低到高',
    sortDesc: '价格从高到低',
    categories: '产品分类',
    results: '个产品',
    in: '属于',
    filterToggle: '分类',
    allTypes: '全部',
    noImg: '无图'
  },
  productDetails: {
    loadingProduct: '产品加载中…',
    notFound: '未找到该产品。',
    backToProducts: '← 返回产品列表',
    keyAttributes: '核心属性',
    moreSpecs: '更多规格',
    blockDescription: '产品描述',
    noDescription: '暂无描述。',
    blockSpecs: '规格参数',
    noSpecs: '暂无规格参数。',
    blockFaq: '常见问题',
    inquiryTitle: '发送询盘',
    inquiryDesc: '告诉我们您的需求 — 通常24小时内回复。',
    priceMeta: '起订1件 · 支持批量折扣'
  },
  example: {
    heroTitle: '项目案例',
    heroDesc: '全球范围内由我们灯光方案驱动的真实安装与舞台演出。',
    ctaWa: '获取同款方案',
    empty: '该分类暂无案例。'
  },
  about: {
    heroTitle: '关于我们',
    heroSub: '广州华阳舞台灯光 — 自2010年起专注于专业舞台灯光制造的厂家。',
    companyEyebrow: '公司简介',
    purposeEyebrow: '我们的使命',
    purposeTitle: '点亮舞台，闪耀未来',
    teamEyebrow: '联系我们的团队',
    teamTitle: '客户服务',
    teamDesc: '直接联系我们的销售专员 — WhatsApp 是最快的报价途径。',
    notSure: '不知道该联系谁？',
    routeMsg: '给我们的总号线留言，我们会为您转接到对应人员。',
    leaveEyebrow: '或留言给我们',
    leaveTitle: '留下您的信息',
    leaveDesc: '也欢迎邮件 — 我们24小时内回复。',
    statYears: '年',
    statCountries: '国家',
    statUnits: '台/年',
    statFactory: '㎡工厂',
    whyList1: '工厂直供价格',
    whyList2: '支持全球发货',
    whyList3: '品质保障'
  },
  footer: {
    productCenter: '产品中心',
    viewAllProducts: '查看全部产品',
    aboutTitle: '关于我们',
    aboutText: '广州华阳舞台灯光成立于2010年，专注于摇头灯、LED灯等舞台灯光设备。产品远销50多个国家，以高品质产品和优质服务著称。',
    contact: '联系方式',
    chatWa: 'WhatsApp 在线沟通',
    rights: '版权所有。',
    waLabel: '最快回复',
    workingHours: '工作时间'
  },
  leaveMessage: {
    fastest: '最快回复',
    title: '在 WhatsApp 上联系我们',
    replyMin: '销售团队在工作时间（{hours}）通常 <b>10分钟</b> 内回复。',
    orEmail: '或发送邮件',
    formTitle: '给我们发邮件',
    formSub: '填写下方表单 — 我们24小时内回复。',
    fullName: '姓名 *',
    fullNamePh: '您的姓名',
    phone: '电话 *',
    phonePh: '请含国家代码',
    emailLbl: '邮箱 *',
    emailPh: 'you@example.com',
    message: '留言内容 *',
    messagePh: '请告诉我们您感兴趣的产品、数量、目的国等。',
    codePh: '请输入验证码',
    privacy: '您的信息将被保密，仅用于回复您的询盘。',
    errCode: '请输入验证码。',
    errForm: '请填写完整有效的信息。',
    okSent: '留言提交成功！',
    errCodeInvalid: '验证码错误，请重试。',
    errFail: '提交失败，请稍后重试。'
  },
  trust: {
    assurance: '交易保障',
    assuranceDesc: '内置订单保护',
    shipping: '全球物流',
    shippingDesc: '海运 / 空运 / 快递',
    quality: '品质检验',
    qualityDesc: '工厂直供'
  },
  stats: {
    years: '14+',
    yearsLbl: '年',
    countries: '50+',
    countriesLbl: '国家',
    units: '10万+',
    unitsLbl: '台/年',
    factory: '7200',
    factoryLbl: '㎡工厂'
  }
};
